import React, { useEffect, useState, useRef, useContext } from 'react'
import axios from 'axios';
import Settings from "../../../AppSettings";
import ServiceSurvey from '../../../services/survey';
import ServiceQuestion from '../../../services/question';
import CustomRadarChart from '../chart/radarchart';
import { Context } from '../../../AppContext';
import { RadialChart } from 'react-vis';
import { Button, CheckBox, Dialog, DialogActions, DialogContent, DialogTitle, Paper, Typography } from '../../ui/core';

export default function Generate({ evaluation, surveys, onClose }) {
    const context = useContext(Context);
    const [charts, setCharts] = useState([])
    const [postData, setPostData] = useState();

    const [showSummary, setShowSummery] = useState(false);
    const [showGeneralResults, setShowGeneralResults] = useState(true);
    const [showDetailResults, setShowDetailResults] = useState(true);
    const [showAttachmentPerQuestion, setShowAttachmentPerQuestion] = useState(false);
    const [showEvaluations, setShowEvaluations] = useState(false);
    const [showFindings, setShowFindings] = useState(false);

    const [checkedSurveys, setCheckedSurveys] = useState([]);

    const ref = useRef();

    const locationAPI = Settings.getLocationOpenDocumentAPI();

    const downloadBase64File = (base64Data, fileName) => {
        const linkSource = `data:application/vnd.openxmlformats-officedocument.wordprocessingml.document;base64,${base64Data}`;
        const downloadLink = document.createElement("a");
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
    }

    const createCharts = async () => {
     //   console.log("evaluation", evaluation)
     //   console.log("surveys", surveys)
        let surveyQuestions = [];
        let surveyScores = [];
        let surveyOpenTexts = [];
        let surveyClosedValues = [];
        let surveyOpenValues = [];
        let colorRanges = [];
        let surveyResults = [];
 let tmpCharts = [];
        for (let s = 0; s < surveys.length; s++) {
            let survey = surveys[s];

            //vragen
            let questions = [];
            try { questions = await ServiceQuestion.getForSurvey(survey._id); } catch (ex) { console.log(ex) }
            //        surveyQuestions.push({ survey: survey, questions: questions });

            //scores
            let scores = [];
            try { scores = await ServiceSurvey.getScores(survey._id); } catch (ex) { console.log(ex) }
            //      surveyScores.push({ survey: survey, scores: scores });

            //score details
            let scoresDetail = [];
            try { scoresDetail = await ServiceSurvey.getScoresDetail(survey._id); } catch (ex) { console.log(ex) }
            //      surveyOpenTexts.push({ survey: survey, openText: scoresDetail.openText  });

            //  surveyClosedValues.push({ survey: survey, closedValues: scoresDetail.closedValues || []});

            //  surveyOpenValues.push({ survey: survey, openValues: scoresDetail.openValues || [] });

            //processes
           
            let mainProcessScore = scores.mainProcessScore || [];
            let subProcessScore = scores.subProcessScore || [];
            //main process score chart
            survey.mainProcesses
                .filter(p => { return p.active === true })
                .forEach(mainProcess => {
                    let tmpScores = [];

                    if (mainProcess && mainProcess.subProcesses) {

                        for (let t = 0; t < mainProcess.subProcesses.length; t++) {

                            if (mainProcess.subProcesses[t].active === true) {

                                let tmpScore = {};
                                tmpScore._id = mainProcess.subProcesses[t]._id;
                                tmpScore.title = mainProcess.subProcesses[t].title;
                                tmpScore.score = 0;
                                let score = subProcessScore.find(i => { return i._id === mainProcess.subProcesses[t]._id });
                                if (score) {
                                    tmpScore.score = score.perc;
                                    tmpScore.color = ServiceSurvey.getColorFromRange(survey.colorRange, score.perc);
                                }
                                tmpScore.max = 100;
                                tmpScores.push(tmpScore);
                            }
                        }
                    }
                    let chart = <CustomRadarChart id={survey._id + "_" + mainProcess._id} key={mainProcess._id} scores={tmpScores} colorRange={survey.colorRange} />

                    tmpCharts.push(chart);


                    surveyResults.push({ survey: survey, questions: questions, scores: scores, openText: scoresDetail.openText, openValues: scoresDetail.openValues || [], closedValues: scoresDetail.closedValues || [] });

                    // colorRanges.push({ survey: survey, colorRange: survey.colorRange });

                });

      //      console.log("surveyQuestion", surveyQuestions)
       //     console.log("surveyScore", surveyScores)

        }
         setCharts(tmpCharts);
        /*
        let questions = [];
        try { questions = await ServiceQuestion.getForSurvey(survey._id); } catch (ex) { console.log(ex) }
 
        let scores = await ServiceSurvey.getScores(survey._id);
        let scoresDetail = await ServiceSurvey.getScoresDetail(survey._id);
 
        let opentext = scoresDetail.openText || [];
        let closedValues = scoresDetail.closedValues || [];
        let openValues = scoresDetail.openValues || [];
 
        let mainProcessScore = scores.mainProcessScore || [];
        let subProcessScore = scores.subProcessScore || [];
 
        let tmpCharts = [];
        //main process score chart
        survey.mainProcesses.filter(p => { return p.active === true }).forEach(mainProcess => {
            let tmpScores = [];
 
            if (mainProcess && mainProcess.subProcesses) {
 
                for (let t = 0; t < mainProcess.subProcesses.length; t++) {
 
                    if (mainProcess.subProcesses[t].active === true) {
 
                        let tmpScore = {};
                        tmpScore._id = mainProcess.subProcesses[t]._id;
                        tmpScore.title = mainProcess.subProcesses[t].title;
                        tmpScore.score = 0;
                        let score = subProcessScore.find(i => { return i._id === mainProcess.subProcesses[t]._id });
                        if (score) {
                            tmpScore.score = score.perc;
                            tmpScore.color = ServiceSurvey.getColorFromRange(survey.colorRange, score.perc);
                        }
                        tmpScore.max = 100;
                        tmpScores.push(tmpScore);
                    }
                }
            }
            let chart = <CustomRadarChart id={mainProcess._id} key={mainProcess._id} scores={tmpScores} colorRange={survey.colorRange} />
 
            tmpCharts.push(chart);
        })
 
        //question chart
        questions.forEach(question => {
            if (question.options) {
                question.options = question.options.filter(q => { return q.active === true })
                scores = closedValues.filter(s => { return s.value >= 0 && s.question == question._id });
 
                if (scores.length === 0) {
                    return null;
                }
                let data = [];
                let bri = 1;
                let briSteps = 1 / question.options.filter(s => { return s.score >= 0 }).length;
                if (question.options) {
                    for (let i = 0; i < question.options.length; i++) {
                        if (question.options[i].score >= 0) {
                            ///console.log( ServiceColor.changeHue("#00698f",hue))
                            let foundScores = scores.filter(s => { return s.value === question.options[i].score })
                            data.push({ id: question.options[i]._id, angle: foundScores.length, style: { fill: `rgba(0,105,143,${bri})`, stroke: `rgba(0,105,143,${bri})` }, colorType: "literal", label: (Math.round(((100 / scores.length) * foundScores.length) * 10) / 10) + '%', text: question.options[i].text })
                            bri = bri - briSteps;//0.2
                        }
                    }
                }
 
                question.chartData = data;
                let chart = <div id={question._id} key={question._id} ><RadialChart showLabels={true} data={data} labelsRadiusMultiplier={0.9} labelsStyle={{ fontSize: "11px", fill: "white", backgroundColor: "black" }} width={200} height={200} /></div>
                tmpCharts.push(chart);
            }
 
        })
 
        setCharts(tmpCharts);
*/
        let colorRange = [];
        let postData = {
            title: evaluation.title,
            colorRange: colorRange,
            subTitle: "",
            author: "",
            showAttachmentPerQuestion: true,
            intro: "In dit document...",
            summary: "Samengevat is het .",
            surveyResults: surveyResults,
            //    surveyQuestions: surveyQuestions,
            //     surveyScores: surveyScores,
            //     surveyOpenTexts:surveyOpenTexts,
            //     surveyClosedValues: surveyClosedValues,
            //      surveyOpenValues: surveyOpenValues,
            //      colorRanges: colorRanges,
            //     mainProcesses: survey.mainProcesses.filter(p => { return p.active === true }),
            //     mainProcessScore: mainProcessScore,// [{ _id: "1", perc: 60 }, { _id: "2", perc: 70 }],
            //    subProcessScore: subProcessScore,// [{ _id: "a", perc: 55 }, { _id: "b", perc: 79 }],
            //   questions: questions,//[{_id:"1",question:"Is opgeschaald op ..",sort:"1"},{_id:"2",question:"Is afgeschaald op ..",sort:"2",image:""}],
            //   opentext: opentext,//[{question:"1",openText:"De waarneming is .."},{question:"2",openText:"De bevinding is .."}],//waarnemingen
            //   closedValues: closedValues,//[{question:"1",perc:80},{question:"2",perc:70}]
            //    openValues: openValues
        }
        setPostData(postData);
    }



    useEffect(() => {
        createCharts();
    }, [])

    const handleDownload = async () => {
        if (postData && ref.current) {
            let tmpPostData = Object.assign({}, postData);
            tmpPostData.headerImage = context.organisation.headerImage || "";
            tmpPostData.footerImage = context.organisation.footerImage || "";
            tmpPostData.surveyResults = tmpPostData.surveyResults.filter(s => { return checkedSurveys.indexOf(s.survey._id) >= 0 });

            tmpPostData.surveyResults.forEach(surveyResult => {
                  surveyResult.survey.mainProcesses.forEach(process => {
                let chart = Array.from(ref.current.children).find(child => { return child.id == surveyResult.survey._id + "_" + process._id });
                if (chart) {
                 //   console.log(chart.outerHTML)
                    process.image = "data:image/svg+xml;base64," + window.btoa(chart.outerHTML);
                }
            })
            })

            tmpPostData.showSummary = showSummary;
            tmpPostData.showGeneralResults = showGeneralResults;
            tmpPostData.showDetailResults = showDetailResults;
            tmpPostData.showEvaluations = showEvaluations;
            tmpPostData.showFindings = showFindings;
            tmpPostData.showAttachmentPerQuestion = showAttachmentPerQuestion;
            /*
            tmpPostData.mainProcesses.forEach(process => {
                let chart = Array.from(ref.current.children).find(child => { return child.id == process._id });
                if (chart) {
                    console.log(chart.outerHTML)
                    process.image = "data:image/svg+xml;base64," + window.btoa(chart.outerHTML);
                }
            })
            tmpPostData.questions.forEach(question => {
                let chart = Array.from(ref.current.children).find(child => { return child.id == question._id });
                if (chart) {
                    question.image = "data:image/svg+xml;base64," + window.btoa(chart.getElementsByTagName("svg")[0].outerHTML);
                }
            })
                */
            axios.post(locationAPI, tmpPostData, {})
                .then(res => {
                    downloadBase64File(res.data, "rapport.docx")
                }, err => {
                    console.log(err);
                })
        }
    }
    /*
    
                <CheckBox id="cbSum" label={"Samenvatting"} checked={showSummary} onChange={() => { setShowSummery(!showSummary) }}></CheckBox>
 
                <CheckBox id="cbGen" label={"Resultaten algemeen"} checked={showGeneralResults} onChange={() => { setShowGeneralResults(!showGeneralResults) }}></CheckBox>
 
              
                <CheckBox id="cbRes" label={"Resultaten evaluatie gesprekken"} checked={showEvaluations} onChange={() => { setShowEvaluations(!showEvaluations) }}></CheckBox>
 
                <CheckBox id="cbFin" label={"Bevindingen"} checked={showFindings} onChange={() => { setShowFindings(!showFindings) }}></CheckBox>
 
                <CheckBox id="cbAtt" label={"Bijlage - beantwoording per vraag"} checked={showAttachmentPerQuestion} onChange={() => { setShowAttachmentPerQuestion(!showAttachmentPerQuestion) }}></CheckBox>
 
                */

    const handleCheckSurvey = (id) => {
        let tmpChecked = Object.assign([], checkedSurveys);
        if (tmpChecked.indexOf(id) >= 0) {
            tmpChecked = tmpChecked.filter(s => { return s !== id });
        } else {
            tmpChecked.push(id);
        }
        setCheckedSurveys(tmpChecked);
    }

    return (
        <Dialog onClose={onClose} fullScreen>
            <DialogTitle ><Typography component="h1">Rapport generator</Typography></DialogTitle>
            <DialogContent>
                Selecteer vragenlijsten die u wilt toevoegen aan het rapport:<br /><br />
                {
                    surveys.map(survey => {
                        return <CheckBox key={survey._id} id={survey._id} label={survey.title} checked={checkedSurveys.indexOf(survey._id) >= 0} onChange={() => { handleCheckSurvey(survey._id) }}></CheckBox>
                    })
                }

                <br />
                Selecteer de gewenste onderdelen:<br /><br />
                <CheckBox id="cbGen" label={"Resultaten algemeen"} checked={showGeneralResults} onChange={() => { setShowGeneralResults(!showGeneralResults) }}></CheckBox>

                <CheckBox id="cbDet" label={"Resultaten gedetaileerd"} checked={showDetailResults} onChange={() => { setShowDetailResults(!showDetailResults) }}></CheckBox>

                <div ref={ref} style={{ display: 'none' }}>
                    {charts.map(c => { return c })}
                </div>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleDownload} disabled={!ref.current || checkedSurveys.length === 0}>Rapport aanmaken & downloaden</Button>
                <Button onClick={onClose} style={{ backgroundColor: '#ff6A13' }}>Sluiten</Button>
            </DialogActions>
        </Dialog>
    )
}
